module.exports = __webpack_public_path__ + "static/artboard_4-6c9329efa85e50901955251fb302924d.svg";